import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './cookie-banner.module.css';
import Remove from '@svg/remove.svg';
import useLocalStorage from '../../../hooks/use-local-storage';

const CONSENT_KEY = 'sistinf-cookie-consent'; // <-- nuova chiave

const CookieBanner = ({ openPrivacyModal, setOpenPrivacyModal }) => {
  const [consent, setConsent] = useLocalStorage(CONSENT_KEY);
  // const [bannerDisplay, setBannerDisplay] = useState(true);

  const accept = () => {
    if (consent !== 'true') {
      setConsent('true');
      window.dispatchEvent(new Event('analytics-consent-granted'));
    }
    if (openPrivacyModal) setOpenPrivacyModal(false);
  };

  // const refuse = () => {
  //   setConsent("false");
  //   // setBannerDisplay(false);
  //   window.dispatchEvent(new Event("analytics-consent-denied"));
  // };

  const closeOnly = () => {
    // setBannerDisplay(false); // NON salva consenso
  };

  // mostra solo se non abbiamo scelta salvata o richiamo dal footer
  const shouldShow = !consent || openPrivacyModal;
  return shouldShow ? (
    <div className={`d-flex ${styles.overlay}`}>
      <div className={`container-fluid bg-white position-fixed ${styles.bannerCookie}`}>
        <div className="row">
          <div className="col snf-color-prussian-blue snf-font-20 font-weight-bold text-center my-3">
            <FormattedMessage
              defaultMessage="Informativa policy"
              description="Title - Banner cookie"
            />
          </div>
          <Remove
            className={`snf-color-denim ${styles.closeIcon}`}
            onClick={() => {
              // setBannerDisplay(false);
              // setConsent('accepted');
              // setOpenPrivacyModal(false)
              accept();
            }}
          />
        </div>
        <div className="row">
          <div className="col text-left snf-color-prussian-blue snf-font-15 my-3 px-3">
            <FormattedMessage
              defaultMessage={`Questo sito utilizza cookie tecnici e cookie analitici di prima parte per raccogliere informazioni aggregate e anonime sull’utilizzo del sito, al fine di migliorarne le prestazioni e l’esperienza utente; per tali cookie non è richiesto il consenso. I dati non vengono condivisi con terze parti. Per maggiori informazioni consulta la <privacy>Privacy Policy</privacy>.`}
              description="Description - Banner cookie"
              values={{
                privacy: (chunks) => (
                  <a
                    href="/assets/Privacy OnLine Sistemi Informativi ITA-PRI 3.01.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-underline snf-color-anchor-blue"
                  >
                    {chunks}
                  </a>
                )
              }}
            />
          </div>
        </div>
        {/* <div className="row">
          <div className="col justify-content-center text-center">
            <button
              type="button"
              className="snf-bg-color-denim snf-font-w6 text-uppercase text-white font-weight-bold py-2 px-3 snf-font-18 border-0 mb-3"
              onClick={() => setCookie('accepted')}
            >
              <FormattedMessage
                defaultMessage="accetta"
                description="Button label - Banner cookie"
              />
            </button>
          </div>
        </div> */}
      </div>
    </div>
  ) : null;
};

export { CookieBanner };
